import { render, staticRenderFns } from "./largeBagShip.vue?vue&type=template&id=738a95cf&scoped=true&"
import script from "./largeBagShip.vue?vue&type=script&lang=js&"
export * from "./largeBagShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a95cf",
  null
  
)

export default component.exports